import { useAppSelector } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';
import { Icon } from '@/shared/ui';

import { organizationModel } from '@/entities/organization';

import { ICON_SIZE, MOBILE_ICON_SIZE } from '../../config';
import { getKnowledgeBaseUrl } from '../../lib';

import styles from './LearningHub.module.scss';

type LearningHubProps = {
  isMobile?: boolean;
};

export const LearningHub = (props: LearningHubProps) => {
  const { isFDA, isFDA3DGPRestrictions } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );

  const knowledgeBaseUrl = getKnowledgeBaseUrl(isFDA || isFDA3DGPRestrictions);

  return knowledgeBaseUrl ? (
    <a
      className={styles.studyIcon}
      data-component="learning-hub-link"
      href={knowledgeBaseUrl}
      referrerPolicy="no-referrer"
      target="_blank"
      onClick={() => {
        trackEvent({
          eventName: 'AllPagesKnowledgeBaseIconClicked',
        });
      }}
    >
      <Icon name="study" size={props.isMobile ? MOBILE_ICON_SIZE : ICON_SIZE} />
    </a>
  ) : null;
};
